var _path, _rect, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01MContCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-3782a30b-b602-408d-a757-89eb5f2fe336",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.65,42.65l-18.26-15.82c-.68-.59-1.69-.59-2.37,0l-17.98,15.82c-1.25,1.1-.47,3.15,1.19,3.15h4.76v16.63c0,1.03.86,1.86,1.91,1.86h22.89c1.05,0,1.91-.83,1.91-1.86v-16.63h4.76c1.67,0,2.44-2.07,1.18-3.16ZM40.41,60.92h-3.29v-8.95h3.29v8.95ZM46.99,60.92h-3.29v-13.4h3.29v13.4ZM53.58,60.92h-3.29v-15.1h3.29v15.1Z",
    fill: "#c8c8c6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.87,
    y: 9,
    width: 4.74,
    height: 18.92,
    rx: 2.3,
    ry: 2.3,
    fill: "#c8c8c6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.87,
    y: 9,
    width: 4.74,
    height: 18.92,
    rx: 2.3,
    ry: 2.3,
    transform: "translate(90.7 -53.79) rotate(90)",
    fill: "#c8c8c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.29,85.67c-6.22.16-12.56-1.13-18.54-4.02-9.69-4.7-16.98-12.89-20.51-23.07-3.53-10.18-2.89-21.12,1.81-30.81,4.7-9.69,12.89-16.98,23.07-20.51,10.18-3.53,21.12-2.89,30.81,1.81,1.18.57,1.68,2,1.1,3.18-.57,1.18-2,1.68-3.18,1.1-8.55-4.15-18.2-4.71-27.18-1.6-8.98,3.11-16.2,9.54-20.35,18.09-4.15,8.55-4.71,18.2-1.6,27.18,3.11,8.98,9.54,16.2,18.09,20.35,5.27,2.55,10.87,3.69,16.35,3.55,12.89-.32,25.17-7.66,31.18-20.04,4.73-9.75,4.77-20.96.13-30.77-.56-1.19-.06-2.61,1.13-3.17,1.19-.56,2.61-.06,3.17,1.13,5.26,11.11,5.21,23.83-.15,34.88-6.8,14.04-20.73,22.35-35.34,22.72Z",
    fill: "#c8c8c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01MContCw);
export default __webpack_public_path__ + "static/media/01_M-CONT-CW.9e334e277eb4156455fc8b198a71bc3f.svg";
export { ForwardRef as ReactComponent };